
import { defineComponent } from 'vue';
import Overlay from '../../../components/Overlay.vue';
import VChart from 'vue-echarts';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { seriesChart, factoryRich } from '@/common/helpers/MonthlyBilling';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';

use([
  BarChart,
  CanvasRenderer,
  SVGRenderer,
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
]);

export default defineComponent({
  name: 'DashboardDailyBilling',

  components: {
    Overlay,
    VChart,
  },

  props: {
    monthlyTotals: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      brands: [] as any,
      options: {
        grid: {
          right: '10',
          left: '140',
          top: 55,
          bottom: 48,
        },
        xAxis: {
          axisLine: {
            show: true,
            axisTick: { show: false },
            lineStyle: {
              color: '#4A4B4D',
            },
          },
          type: 'category',
          axisLabel: {
            formatter: () => '',
          },
        },
        yAxis: {
          axisLine: {
            show: true,
            lineStyle: {
              color: '#4A4B4D',
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: { show: false },

          type: 'value',
          axisLabel: {
            formatter: '{value}',
          },
        },
        series: [],
      },
    };
  },

  methods: {
    gerarSeries() {
      this.monthlyTotals.brands.forEach((element) => {
        this.brands.push(element.brand.toLowerCase().split(' ').join(''));
      });

      const seriesData = seriesChart(this.monthlyTotals as any);

      var series = [
        {
          name: 'chartName',
          cursor: 'normal',
          type: 'bar',
          silent: true,
          barWidth: '50px',
          stack: 'Acessórios',
          data: seriesData.dataAcessorio,
          label: {
            show: true,
            position: 'bottom',
            color: '#fff',
            formatter: (value: any) =>
              `{value| ${
                seriesData.maskValueAcessorio[value.dataIndex]
              }} \n {segment|}`,
            rich: {
              value: {
                lineHeight: 17,
                verticalAlign: 'top',
                align: 'center',
                padding: [-28, 0, 0, 0],
              },
              segment: {
                height: 28,
                align: 'center',
                lineHeight: 2,
                verticalAlign: 'bottom',
                padding: [0, 0, 0, 0],
                backgroundColor: {
                  image: this.icons.acessories,
                },
              },
            },
          },
          itemStyle: {
            color: '#00AFD7',
          },
        },
        {
          name: 'Faltante',
          cursor: 'normal',
          type: 'bar',
          silent: true,
          stack: 'Acessórios',
          itemStyle: {
            borderRadius: [4, 4, 0, 0],
            color: (value: any) =>
              seriesData.colorAcessorioFaltante[value.dataIndex],
          },
          label: {
            show: true,
            position: 'top',
            formatter: (value: any) => {
              if (!value.value) {
                return '';
              } else
                return `{value|${
                  seriesData.maskValueAcessorioFaltante[value.dataIndex]
                }}`;
            },
            rich: {
              value: {
                lineHeight: 0,
                align: 'center',
              },
              fila: {
                height: 19,
                lineHeight: 40,
                backgroundColor: {
                  image: this.icons.fila,
                },
              },
              filaacessorios: {
                height: 19,
                lineHeight: 40,
                backgroundColor: {
                  image: this.icons.fila,
                },
              },
              umbro: {
                height: 22,
                lineHeight: 40,
                align: 'center',
                backgroundColor: {
                  image: this.icons.umbro,
                },
              },
              newbalance: {
                height: 22,
                lineHeight: 40,
                align: 'center',
                backgroundColor: {
                  image: this.icons.newbalance,
                },
              },
            },
          },
          data: seriesData.dataAcessorioFaltante,
        },

        //------------------------------

        {
          name: 'chartName',
          cursor: 'normal',
          type: 'bar',
          silent: true,
          barWidth: '50px',
          radius: ['10%'],
          stack: 'Calçados',
          data: seriesData.dataCalcado,

          label: {
            show: true,
            position: 'bottom',
            color: '#fff',
            padding: [-16, 0, 0, 0],
            formatter: (value: any) =>
              `{value| ${
                seriesData.maskValueCalcado[value.dataIndex]
              }} \n {segment|}`,
            rich: {
              value: {
                lineHeight: 15,
                verticalAlign: 'top',
                align: 'center',
                padding: [-10, 0, 0, 0],
              },
              segment: {
                height: 34,
                align: 'center',
                verticalAlign: 'bottom',
                backgroundColor: {
                  image: this.icons.shoes,
                },
              },
            },
          },
          itemStyle: {
            color: '#00AFD7',
          },
        },
        {
          name: 'Faltante',
          cursor: 'normal',
          type: 'bar',
          stack: 'Calçados',
          silent: true,
          label: {
            show: true,
            position: 'top',
            formatter: (value: any) => {
              if (!value.value)
                return `{${seriesData.brands[value.dataIndex]
                  .toLowerCase()
                  .split(' ')
                  .join('')}|} `;
              else {
                return `{${seriesData.brands[value.dataIndex]
                  .toLowerCase()
                  .split(' ')
                  .join('')}|} \n {value|${
                  seriesData.maskValueCalcadoFaltante[value.dataIndex]
                }}`;
              }
            },
            rich: {
              value: {
                lineHeight: 0,
                align: 'center',
              },
              ...factoryRich(),
            },
          },
          itemStyle: {
            borderRadius: [4, 4, 0, 0],
            color: (value: any) =>
              seriesData.colorCalcadoFaltante[value.dataIndex],
          },
          data: seriesData.dataCalcadoFaltante,
        },

        // --------------------------

        {
          name: 'chartName',
          cursor: 'normal',
          type: 'bar',
          stack: 'Confecção',
          barWidth: '50px',
          silent: true,
          data: seriesData.dataConfeccao,

          label: {
            show: true,
            position: 'bottom',
            color: '#fff',
            formatter: (value: any) => {
              return `{value| ${
                seriesData.maskValueConfeccao[value.dataIndex]
              }} \n {segment|}`;
            },
            rich: {
              value: {
                lineHeight: 14,
                verticalAlign: 'top',
                align: 'center',
                padding: [-28, 0, 0, 0],
              },
              segment: {
                height: 24,
                align: 'center',
                verticalAlign: 'bottom',
                lineHeight: 10,
                backgroundColor: {
                  image: this.icons.confection,
                },
              },
            },
          },
          itemStyle: {
            color: '#00AFD7',
          },
        },
        {
          name: 'Faltante',
          cursor: 'normal',
          type: 'bar',
          stack: 'Confecção',
          silent: true,
          itemStyle: {
            borderRadius: [4, 4, 0, 0],

            color: (value: any) =>
              seriesData.colorConfeccaoFaltante[value.dataIndex],
          },
          label: {
            show: true,
            position: 'top',
            formatter: (value: any) => {
              if (!value.value) return '';
              else
                return `{value|${
                  seriesData.maskValueConfeccaoFaltante[value.dataIndex]
                }}`;
            },
            rich: {
              value: {
                lineHeight: 0,
                align: 'center',
              },
              fila: {
                height: 19,
                lineHeight: 40,
                align: 'center',
                backgroundColor: {
                  image: this.icons.fila,
                },
              },
              filaacessorios: {
                height: 19,
                lineHeight: 40,
                backgroundColor: {
                  image: this.icons.fila,
                },
              },
              umbro: {
                height: 22,
                lineHeight: 40,
                align: 'center',
                backgroundColor: {
                  image: this.icons.umbro,
                },
              },
              newbalance: {
                height: 22,
                lineHeight: 40,
                align: 'center',
                backgroundColor: {
                  image: this.icons.newbalance,
                },
              },
            },
          },
          data: seriesData.dataConfeccaoFaltante,
        },
      ];
      (this.$refs['chart'] as any).setOption({ series });
    },
  },

  watch: {
    monthlyTotals: {
      handler() {
        this.gerarSeries();
      },
      deep: true,
    },
  },
  setup() {
    const icons = {
      acessories: require('@/assets/images/acessories.svg'),
      shoes: require('@/assets/images/shoes.svg'),
      confection: require('@/assets/images/confection.svg'),
      fila: require('@/assets/images/fila-logo.svg'),
      umbro: require('@/assets/images/umbro-logo.svg'),
      newbalance: require('@/assets/images/newbalance-logo.svg'),
    };

    return { icons };
  },
});
